import { createReducer, on } from '@ngrx/store';
import * as NavActions from '../actions/nav.action';

export interface NavState {
  menuOpen: boolean;
  funnel: boolean;
}

export const initialState: NavState = {
  menuOpen: false,
  funnel: false,
};

export const NavReducer = createReducer(
  initialState,
  on(NavActions.OpenMenu, state => {
    return {
      ...state,
      menuOpen: true,
    };
  }),
  on(NavActions.CloseMenu, state => {
    return {
      ...state,
      menuOpen: false,
    };
  }),
  on(NavActions.ToggleMenu, state => {
    return {
      ...state,
      menuOpen: !state.menuOpen,
    };
  }),
  on(NavActions.EnableFunnel, state => {
    return {
      ...state,
      funnel: true,
    };
  }),
  on(NavActions.DisableFunnel, state => {
    return {
      ...state,
      funnel: false,
    };
  })
);

export const getMenuOpen = (state: NavState) => state.menuOpen;
export const getIsFunnel = (state: NavState) => state.funnel;
